import "../App.css";
import { useState } from "react";
// sfx utils
import { playButtonSelect } from "../utils/sfx.js";
// bootstrap
import { Row, Col } from "react-bootstrap";
// image
import FocusImage from "../assets/altgirlie.png";
// icons
import { IoLibrary, IoDocumentText } from "react-icons/io5";
import { BsDatabaseFill } from "react-icons/bs";
import { MdManageAccounts, MdAutoGraph, MdViewQuilt, MdOutlineNavigateNext, MdOutlineNavigateBefore } from "react-icons/md";
import { PiDesktopTowerFill, PiPottedPlantFill } from "react-icons/pi";
import { FaMobileAlt, FaGitAlt, FaLinkedin, FaGithub, } from "react-icons/fa";
import { RiChatSmileAiFill } from "react-icons/ri";
import { LuImageUpscale } from "react-icons/lu";
import { BiSolidInjection, BiLogoGmail } from "react-icons/bi";

export default function Home() {
	const [page, setPage] = useState(0);
	const skillsPerPage = 3;

	const stats = [
		{ name: "Git/GitHub", percentage: 0.95, },
		{ name: "HTML/CSS", percentage: 0.85, },
		{ name: "React", percentage: 0.75, },
		{ name: "JavaScript", percentage: 0.65, },
		{ name: "Vue", percentage: 0.55, },
		{ name: "Flutter", percentage: 0.80, },
		{ name: "Kotlin", percentage: 0.55, },
		{ name: "SQL", percentage: 0.75, },
		{ name: "NoSQL", percentage: 0.50, }
	];

	const skills = [
		{ name: "Web Development", icon: PiDesktopTowerFill, desc: "HTML/CSS, JavaScript, React, Vue, PHP, Node", color: "yellow" },
		{ name: "Mobile App Development", icon: FaMobileAlt, desc: "Flutter, Kotlin", color: "lightgreen" },
		{ name: "Responsive design", icon: LuImageUpscale, desc: "Flexbox, CSS Grid", color: "pink" },
		{ name: "RESTful API", icon: BiSolidInjection, desc: "Data fetching, Axios, HTTP methods", color: "lightgreen" },
		{ name: "Data Visualization & Analytics", icon: MdAutoGraph, desc: "Power BI, RapidMiner", color: "yellow" },
		{ name: "UI/UX Design", icon: MdViewQuilt, desc: "Figma, mockups, wireframes", color: "pink" },
		{ name: "Code Version Control", icon: FaGitAlt, desc: "Git, GitHub", color: "pink" },
		{ name: "Project Management", icon: MdManageAccounts, desc: "Agile SDLC, Kanban boards", color: "lightgreen" },
		{ name: "Database Management", icon: BsDatabaseFill, desc: "MySQL, Firebase, CRUD operations", color: "yellow" },
		{ name: "Research", icon: IoLibrary, desc: "Documentation, mixed-method research, thematic analysis", color: "lightgreen" },
		{ name: "Soft Skills", icon: RiChatSmileAiFill, desc: "Problem solving, teamwork, AI prompt engineering", color: "pink" },
		{ name: "Productivity Software", icon: PiPottedPlantFill, desc: "Office Suite, Google Workspace, Canva, Trello", color: "yellow" },
	];

	const links = [
		{ icon: FaLinkedin, link: "https://www.linkedin.com/in/francespiaalexyrey/" },
		{ icon: FaGithub, link: "https://github.com/definitelynotpia" },
		{ icon: BiLogoGmail, link: "mailto:frances.rey@ciit.edu.ph" },
		{ icon: IoDocumentText, link: "https://drive.google.com/file/d/1sa8_RJUM_WMwNNj8FGIJLdwS5rVbedze/view?usp=sharing" },
	];

	const start = page * skillsPerPage;
	const visibleSkills = skills.slice(start, start + skillsPerPage);
	const totalPages = Math.ceil(skills.length / skillsPerPage);

	// page controller
	const nextPage = () => {
		setPage((prev) => (prev >= totalPages - 1 ? 0 : prev + 1));
	};

	const prevPage = () => {
		setPage((prev) => (prev <= 0 ? totalPages - 1 : prev - 1));
	};

	const handleSubmit = (e) => {
		e.preventDefault();

		const form = e.target;
		const data = new FormData(form);

		fetch("/", {
			method: "POST",
			headers: { "Content-Type": "application/x-www-form-urlencoded" },
			body: new URLSearchParams(data).toString(),
		})
			.then(() => {
				alert("Message sent!"); // show alert
				window.location.href = "/"; // redirect to home
			})
			.catch((error) => alert("Error sending message: " + error));
	};

	return (
		<div className="content">
			<div className="image-bg home"></div>

			<div className="image-wrapper">
				<div className="mid-col d-flex">
					<img src={FocusImage} alt="Pia Rey"
						height="88%" className="focus-image align-self-end mx-auto" />
				</div>

				<div className="left-col">
					<div className="header glitch" data-text="PIA REY">PIA REY</div>
					<div className="textbox name focus-holo my-4" >
						<div className="name-border-bottom"></div>
						{/* <h3 className="fw-bold">PIA REY</h3> */}
						<p className="fw-normal px-4 pt-4 pb-3">Pia is a creative and detail-oriented <span className="highlight fw-bold">Frontend Developer</span> with a passion for building inclusive, meaningful technology for social good. Her work is people-centered and empathy-driven. She believes UI/UX development is about crafting intuitive, fluid, and personalized experiences.</p>
					</div>

					<div className="textbox contact secondary-holo flex-grow-1 h-100">
						<h5 className="fw-bold text-center mb-3">CONTACT ME</h5>
						<form name="contact" method="POST" className="d-flex flex-column flex-grow-1" onSubmit={handleSubmit} data-netlify="true" netlify>
							<input type="hidden" name="form-name" value="contact" />
							<div className="d-flex flex-row form-info">
								<input name="name" class="form-control form-control-sm" type="text" placeholder="Full Name" aria-label=".full-name" required />
								<input name="email" class="form-control form-control-sm" type="email" placeholder="Email" aria-label=".email" required />
							</div>
							{/* message */}
							<textarea name="message" class="form-control form-control-sm my-3 flex-grow-1" placeholder="Message" aria-label=".message" required />
							<button class="form-button align-self-end" type="submit">Send</button>
						</form>
					</div>
				</div>

				<div className="right-col d-flex flex-column justify-content-center align-items-center">
					{/* Stats box */}
					<div className="d-flex">
						<div className="textbox stats secondary-holo" >
							<div className="holo-border-top"></div>
							<h5 className="text-center fw-bold pb-2">STATS</h5>
							<div className="stat-items">
								{stats.map((stat, i) => {
									const width = stat.percentage * 100;
									return (<Row key={i} className="m-0 p-0">
										<Col className="col-4">{stat.name}</Col>
										<Col className="col-6 px-0 m-auto progress-container">
											<div class="progress-bar" style={{ width: `${width}%` }}></div>
										</Col>
									</Row>);
								})}
							</div>
						</div>

						<div className="links d-flex flex-column justify-content-between ms-5">
							{links.map((link, i) => (
								<div key={i} className="polygon icon-lg button-holo d-flex" onClick={() => { window.open(link.link, "_blank") }}>
									<link.icon className="d-flex align-self-center justify-self-center flex-fill" size={40} />
								</div>
							))}
						</div>
					</div>

					{/* Skills (paginated) */}
					<div className="skills ms-4">
						<h5 className="skill-title ribbon-holo justify-self-start">SKILLS</h5>
						{visibleSkills.map((skill, i) => {
							const marginValue = i * 50;
							return (
								<div key={i} style={{ marginLeft: `${marginValue}px` }} className="skill-item" >
									<div className="polygon icon-sm button-holo">
										<skill.icon className="align-self-center justify-self-center" size={24} color={skill.color} />
									</div>
									<div className="polygon-text secondary-holo">
										<div className="skill-name">{skill.name}</div>
										<div className="skill-desc">{skill.desc}</div>
									</div>
								</div>
							);
						})}

						<div className="pagination-controls">
							<button className="prev-btn" onClick={() => { prevPage(); playButtonSelect(); }}><MdOutlineNavigateBefore /></button>
							<button className="next-btn" onClick={() => { nextPage(); playButtonSelect(); }}><MdOutlineNavigateNext /></button>
						</div>
					</div>
				</div>
			</div>
		</div>
	);
}
